import { ColumnDef } from "@tanstack/react-table";
import { DataTableColumnHeader } from "./data-table-column-header";
import { DataTableRowActions } from "./data-table-row-actions";
import { CanReceiveEmailToggle } from "./CanReceiveEmailToggle";

export const columns: ColumnDef<any>[] = [
  {
    accessorKey: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Nome" />
    ),
  },
  {
    accessorKey: "code",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Loja" />
    ),
  },
  {
    accessorKey: "regional.name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Regional" />
    ),
  },
  {
    id: "storeEmail",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Email Loja" />
    ),
    cell: ({ row }) => {
      const emails = row.original.emails || [];
      const storeEmail = emails.find((email: any) => email.type === "STORE");
      return storeEmail ? storeEmail.email : "-";
    },
  },
  {
    id: "managementEmail",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Email Gerência" />
    ),
    cell: ({ row }) => {
      const emails = row.original.emails || [];
      const managementEmail = emails.find((email: any) => email.type === "MANAGEMENT");
      return managementEmail ? managementEmail.email : "-";
    },
  },
  {
    id: "canReceiveEmail",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Recebe Email?" />
    ),
    cell: ({ row }) => {
      const { can_receive_email, code } = row.original;
      return (
        <div className="flex items-center justify-center">
          <CanReceiveEmailToggle code={String(code)} value={can_receive_email} />
        </div>
      );
    },
  },
  {
    id: "actions",
    header: "Ações",
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
];
